<template>
  <portal to="overlay-portal">
    <Overlay v-if="open">
      <nav class="nav-Mobile">
        <MobileMenuToggle collapsed class="pt-3 pr-2 d-block ml-auto" />
        <div class="mt-2">
          <slot></slot>
        </div>
      </nav>
    </Overlay>
  </portal>
</template>

<script>
import { mapGetters } from "vuex";
import MobileMenuToggle from "./MobileMenuToggle";
import Overlay from "./Overlay";

export default {
  name: "MobileMenuContent",
  components: {
    MobileMenuToggle,
    Overlay,
  },
  computed: {
    ...mapGetters({
      open: "getNavigationOpenState",
    }),
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.nav-Mobile {
  background-color: $gray-200;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  z-index: $zi-mobilenav;

  @media (min-width: $screen-lg-min) {
    display: none;
  }
}
</style>
